import { initialLoginState, LoginState } from 'login/store/LoginState';
import { LoginActionType, LoginAction } from './actions';
import { Reducer } from 'redux';

const loginReducer: Reducer<LoginState, LoginAction> = (
    state = initialLoginState,
    action
) => {
    switch (action.type) {
        case LoginActionType.LOGIN_STATE_CHANGE:
            return action.payload!;
        case LoginActionType.LOGIN_STATE_RESET:
            return initialLoginState;
        case LoginActionType.HAS_AGREED_CHANGE:
            return {
                ...state,
                result: { ...state.result!, agreedTerms: action.payload! },
            };
        default:
            return state;
    }
};

export default loginReducer;
